<script lang="ts">
	import { appState } from "$lib/state/app-state.svelte";
	import { slugComparator } from "$lib/navigation/navigation";
	import type { DocumentGroup } from "$lib/navigation/document-group";

	interface Props {
		class: string;
		groups: DocumentGroup[];
		slug: string;
	}

	const { class: className, groups, slug }: Props = $props();
	const links = $derived(appState.links);
</script>

{#if groups}
	<!-- svelte-ignore a11y_click_events_have_key_events -->
	<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
	<nav class={className} onclick={() => (appState.menuVisible = false)}>
		<ul role="list">
			<li class="md:hidden">
				<a
					class="block py-1 text-sm text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white"
					href={links.click4survey.href}>{links.click4survey.label}</a>
			</li>
			<li class="md:hidden">
				<a
					class="block py-1 text-sm text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white"
					href={links.plansAndPrices.href}>{links.plansAndPrices.label}</a>
			</li>
			<li class="md:hidden">
				<a
					class="block py-1 text-sm text-zinc-600 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white"
					href={links.support.href}>{links.support.label}</a>
			</li>

			{#each groups as group (group.id)}
				<li class={["relative mt-6", group.order == 0 ? "md:mt-0" : ""]}>
					<h2 class="text-xs font-semibold text-zinc-600 uppercase dark:text-white">{group.label}</h2>
					<div class="relative mt-3 pl-0">
						<div class="absolute inset-y-0 left-2 w-px bg-zinc-900/10 dark:bg-white/5"></div>

						<ul role="list" class="border-l border-transparent">
							{#each group.documents as document (document.slug.join("/"))}
								{@const isActive = slugComparator(document, slug)}
								{@const link = `/${document.slug.join("/")}/`}
								<li class="relative pl-2">
									{#if isActive}
										<div
											class="bg-primary-600 absolute left-2 h-6 w-[2px]"
											style="top: 4px; opacity: 1;">
										</div>
									{/if}
									<a
										class="flex justify-between gap-2 py-1 pr-3 pl-4 text-sm text-zinc-900 dark:text-white"
										href={link == "//" ? "/" : link}
										aria-current={isActive ? "page" : undefined}>
										<span class={[isActive && "font-semibold"]}>{document.title}</span>
									</a>
									{#if isActive && document?.headings}
										<ul role="list">
											{#each document.headings as heading (heading.id)}
												<li class="relative">
													<a
														class="flex justify-between gap-2 py-1 pr-3 pl-7 text-sm text-zinc-400 hover:text-zinc-900 dark:text-zinc-400 dark:hover:text-white"
														href={`#${heading.id}`}>
														<span class="relative z-10">{heading.title}</span>
													</a>
												</li>
											{/each}
										</ul>
									{/if}
								</li>
							{/each}
						</ul>
					</div>
				</li>
			{/each}
		</ul>
	</nav>
{/if}
